import React, {useEffect, useState} from "react";
import {apiList, apiDelete} from "../../../../services/Admin/rate";
import {Button, Grid, Paper, IconButton } from "@mui/material";
import MsgError from "../../../../components/MsgError";
import MsgSuccess from "../../../../components/MsgSuccess";
import HeaderPage from "../../../../components/Admin/HeaderPage";
import Table from "../../../../components/Table";
import {RouteAdmin} from "../../../../routes/RouteAdmin";
import {DASH_MAX_ROW} from "../../../../utils/constants";
import InputSelect from "../../../../components/Inputs/InputSelect";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ModalRemove from "../../../../components/Modal/ModalRemove";

import HighlightOffIcon from '@mui/icons-material/HighlightOff';

import {apiList as apiListRoute} from "../../../../services/Admin/route";

export default function Management() {
    const [rows, setRows] = useState([])
    const [msgError, setMsgError] = useState([])
    const [msgSuccess, setMsgSuccess] = useState([])
    const [loading, setLoading] = useState(true)
    const [rowCount, setRowCount] = useState(0)
    const [state, setState] = useState(initialValues)
    const [openModalRemove, setOpenModalRemove] = useState(false)
    const [isRemoveConfirm, setIsRemoveConfirm] = useState(false)
    const [idRemove, setIdRemove] = useState(null)

    useEffect(() => {
        setLoading(true)
        const timeOutId = setTimeout(() => {
            getItemsData()
        }, 500)
        return () => clearTimeout(timeOutId)
    }, [state])

    const getItemsData = () => {
        setMsgError([])
        
        let field = state.sort.field
     
        let params = {
            limit: DASH_MAX_ROW,
            offset: state.offset ?? 0,
            field: field,
            sort: state.sort.sort
        }

        if (state.idRoute) { params.idRoute = state.idRoute }
    
        apiList(params).then(resp => {
            setRowCount(resp.data?.count)

            let temp = resp.data.data?.map(doc => {
                return {
                    // roleName: doc?.role?.niceName,
                    // access: doc.isActive ? "Si" : "No",
                    // active: moment.unix(doc.lastActivity).format("D/M/Y"),
                    ...doc,
                }
            })

            setRows(temp)
            setLoading(false)
        }).catch(err => {
            setMsgError(err.response?.data?.msg)
            setLoading(false)
            setRows([])
        })
    }

    useEffect(() => {
        if (isRemoveConfirm) {
            
            apiDelete(idRemove).then(resp => {
                setMsgSuccess(resp.data?.msg)
                setIsRemoveConfirm(false)
                setIdRemove(null)
                getItemsData()
            }).catch(err => {
                setMsgError(err.response?.data?.msg)
                setIsRemoveConfirm(false)
                setIdRemove(null)
                getItemsData()           
            })   
        }
    }, [isRemoveConfirm])

    const removeRow = (id) => {
        setIdRemove(id)
        setOpenModalRemove(true)
    }

    return (
        <>
          <ModalRemove
                open={openModalRemove}
                setOpen={setOpenModalRemove}
                setIsRemoveConfirm={setIsRemoveConfirm}
            />
            <HeaderPage title="Tarifas">
                <Button
                    variant="contained"
                    color="primary"
                    style={{float: "right", margin: "20px 0px"}}
                    href={RouteAdmin.RATES_CREATE.path}
                >
                    + Añadir
                </Button>
            </HeaderPage>

            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <MsgError msg={msgError}/>
                    <MsgSuccess msg={msgSuccess}/>
                </Grid>

                <Grid item xs={12}>

                    <Paper sx={{p: 2, display: 'flex', flexDirection: 'column'}}>

                        <Filters
                            state={state}
                            setState={setState}
                            setLoading={setLoading}
                            setMsgError={setMsgError}
                        />

                        <Table
                            columns={tableColumns(removeRow)}
                            rows={rows}
                            rowCount={rowCount}
                            filter={state}
                            setFilter={setState}
                            loading={loading}
                            checkbox={true}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
}

function initialValues(props) {
    return {
        offset: 0,
        sort: { field: "id", sort: "asc" },
        name:"",
        idRoute:"",
    }
}

function tableColumns(removeRow) {
    return [
        {
            field: "idRoute",
            headerName: "ID",
        },
        {
            field: "routeCod",
            headerName: "COD",
        },
        {
            field: "routeName",
            headerName: "LÍNEA",
            flex: 1
        },
        {
            field: "actions",
            headerName: "ACCIONES",
            renderCell: (params) => {
                return (<><Link to={`${RouteAdmin.RATES_EDIT.path}/${params.row.idRoute}`}>
                            <IconButton color="primary" aria-label="edit ruta" size="small">
                                <EditIcon fontSize="inherit" />
                            </IconButton>
                        </Link>

                          <IconButton color="primary" aria-label="delete ruta" size="small" onClick={() => removeRow(params.row.idRoute)}>
                            <DeleteIcon fontSize="inherit"/>
                        </IconButton></>)
            },
        },
    ]
}

function Filters(props) {

    const {state, setState, setLoading, setMsgError} = props
    const {t} = useTranslation()
    const [route, setRoute] = useState([])

    useEffect(() => {void getRoute()}, [])


    const handleChange = (event) => {
        state[event.target.name] = event.target.value
        state["offset"] = 0
        setState({...state})
    }

    const getRoute = () => {

        apiListRoute({
            field: "name",
            sort: "asc"
        }).then(resp => {
            setRoute(resp.data?.data)
        }).catch(err => {
            setLoading(false)
            setMsgError(err.response?.data?.msg)
        })
    }

    return (
        <Grid container spacing={1} style={{marginBottom: '20px'}}>
            <Grid item xs={6}>
            <InputSelect
                label="Línea"
                name="idRoute"
                onChange={handleChange}
                value={state?.idRoute}
                options={route || []}
            />
            </Grid>
             <Grid item xs={3}>
                <Button onClick={() => setState(initialValues())}>
                <HighlightOffIcon/>
                </Button>
            </Grid>
        </Grid>

    )
}
